import React from 'react'
import { Link } from 'react-router-dom'
import Images from '../../assets/images'
import './style.scss'

const Footer = ({ data }) => {
  let footerData = data;
  const LIVE_SITE_URL = process.env.REACT_APP_LIVE_SITE_URL;

  if (!footerData) {
    try {
      footerData = JSON.parse(localStorage.getItem('homeData')) || null;
    } catch (e) {
      footerData = null;
    }
  }

  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-card footer-card-new">
          <div className="footer-row">
            <div className="content-footer">
              <h2 className="footer-title">
                {footerData?.downloadApp?.title}
              </h2>
              <p className="footer-subtitle">
                {footerData?.downloadApp?.description}
              </p>

              <div className="follow-us">
                <span className="follow-label">Follow Us On :</span>
                <div className="social-links">
                  {footerData?.socialLinks?.facebook?.enabled && (
                    <a
                      href={footerData?.socialLinks?.facebook?.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Facebook"
                      className="social-icon"
                    >
                      <img src={Images.facebook} alt="Facebook" />
                    </a>
                  )}

                  {footerData?.socialLinks?.instagram?.enabled && (
                    <a
                      href={footerData?.socialLinks?.instagram?.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Instagram"
                      className="social-icon"
                    >
                      <img src={Images.instagram} alt="Instagram" />
                    </a>
                  )}

                  {footerData?.socialLinks?.tiktok?.enabled && (
                    <a
                      href={footerData?.socialLinks?.tiktok?.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="TikTok"
                      className="social-icon"
                    >
                      <img src={Images.ticktok} alt="TikTok" />
                    </a>
                  )}

                  {footerData?.socialLinks?.linkedin?.enabled && (
                    <a
                      href={footerData?.socialLinks?.linkedin?.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="LinkedIn"
                      className="social-icon"
                    >
                      <img src={Images.linkedin} alt="LinkedIn" />
                    </a>
                  )}

                  {footerData?.socialLinks?.youtube?.enabled && (
                    <a
                      href={footerData.socialLinks?.youtube?.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="YouTube"
                      className="social-icon"
                    >
                      <img src={Images.youtube} alt="YouTube" />
                    </a>
                  )}
                </div>

              </div>
            </div>

            <div className="footer-cta">
              <div className="store-columns">
                <div className="store-column">
                  <div className="store-label">For User :</div>
                  <div className="store-badges">
                    <a href={footerData?.downloadApp?.androidAppLink} target='_blank' rel="noreferrer" className="store-link" aria-label="Get it on Google Play (User)">
                      <img src={Images.googlePlayFooter} alt="Get it on Google Play" />
                    </a>
                    <a href={footerData?.downloadApp?.iosAppLink} target='_blank' rel="noreferrer" className="store-link" aria-label="Download on the App Store (User)">
                      <img src={Images.appPlayFooter} alt="Download on the App Store" />
                    </a>
                  </div>
                </div>

                <div className="store-column">
                  <div className="store-label">For Pilot :</div>
                  <div className="store-badges">
                    <a href={footerData?.downloadApp?.androidPilotAppLink} target='_blank' rel="noreferrer" className="store-link" aria-label="Get it on Google Play (Pilot)">
                      <img src={Images.googlePlayFooter} alt="Get it on Google Play" />
                    </a>
                    <a href={footerData?.downloadApp?.iosPilotAppLink} target='_blank' rel="noreferrer" className="store-link" aria-label="Download on the App Store (Pilot)">
                      <img src={Images.appPlayFooter} alt="Download on the App Store" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-bottom row align-items-center">
            <div className="col-lg-6 col-12 d-flex justify-content-lg-start justify-content-center">
              <div className="footer-links">
                <Link to={`${LIVE_SITE_URL}terms-conditions`} className='text-decoration-underline'>Terms Of Services</Link>
                <Link to={`${LIVE_SITE_URL}privacy-policy`} className='text-decoration-underline'>Privacy Policy</Link>
                <Link to="/contact"  className='text-decoration-underline'>Contact Us</Link>
              </div>
            </div>
            <div className="col-lg-6 col-12 d-flex justify-content-lg-end justify-content-center">
              <p className="copyright mb-0">© 2025 SkyyTask. All Rights Reserved.</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer
